import Button from "components/button";
import { Calendar } from "components/customIcons";
import { DropdownMenu } from "components/dropdownMenu";
import { IFipixEventItem } from "interfaces";
import moment from "moment";
import { DEFAULT_BANNER_URL } from "utills/constants";
import { isHaveActionPermission } from "utills/helpers";

interface EventCardProps {
  data?: IFipixEventItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, action: string) => void;
}


export const EventCard = ({
  data = [],
  _toggleActive
} : EventCardProps) => {
  return (
    <div className="bg-white grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {data.map((item: IFipixEventItem, index: number) => (
        <div className="flex flex-col shadow-md rounded-xl border-solid border-[#C5CCD2] border-[1px]" key={item.id}>
          <div className="relative w-full overflow-hidden pt-4 px-4">
            <img
              src={item.banner_url ?? DEFAULT_BANNER_URL}
              alt={`${item.name_en} Banner`}
              className="rounded-lg"
            />
            <div className="flex items-center gap-x-2 absolute top-7 right-7">
              <div className={`px-2.5 py-1 rounded-lg ${item.is_active ? "bg-[#00A67E] text-white" : "bg-white text-[#A8B3BD]"}`}>
                <p className="text-sm font-medium capitalize">{item.is_active ? "Active" : "Inactive"}</p>
              </div>
              {(item.hidden && item.is_active) ? (
                <div className="px-2.5 py-1 rounded-lg bg-[#FEEFE7] text-[#F1600D]">
                  <p className="text-sm font-medium capitalize">Hidden</p>
                </div>
              ) : <></>}
            </div>
          </div>
          <div className="text-sm 2xl:text-base flex flex-col justify-center items-start py-4 px-4 sm:px-6">
            <p className="text-lg font-bold line-clamp-2">{item.name_en}</p>
            <div className="w-full flex flex-row items-start gap-x-2 mt-4">
              <div className="w-fit shrink-0 self-center">
                <Calendar />
              </div>
              <p>{item.start_date ? moment(item.start_date).format("DD MMMM, YYYY") : ""}</p>
            </div>
          </div>
          <div className="mt-auto w-full flex flex-row-reverse flex-wrap justify-between items-center gap-2 py-4 px-4 sm:px-6">
            <div className="shrink-0 flex flex-row items-center gap-x-2.5">
              <DropdownMenu
                position="top"
                label={
                  <div className="text-sm w-fit bg-white rounded-md px-3 text-brand-500 font-bold py-2 border-solid border-brand-500 border-[1px] hover:bg-white active:bg-white active:opacity-85">
                    More actions
                  </div>
                }
                items={[
                  {
                    label: "Detail",
                    href: `/fipix/events/${item.id}`,
                  },
                  ...(isHaveActionPermission("events", "fipix", "edit")
                    ? [
                        {
                          label: "Edit",
                          href: `/fipix/events/${item.id}/edit`,
                        },
                        ...(item.is_active
                          ? [
                              {
                                label: item.hidden
                                  ? "Show in list"
                                  : "Hide in list",
                                onClick: () =>
                                  _toggleActive(
                                    item.id,
                                    item.hidden ? "display" : "hidden"
                                  ),
                              },
                            ]
                          : []),
                      ]
                    : []),
                ]}
              />
              {isHaveActionPermission("events", "fipix", "edit") ? (
                <Button 
                  className="text-sm w-fit border-solid border-brand-500 border-[1px] py-2"
                  onClick={() => _toggleActive(item.id, item.is_active ? "deactivate" : "activate")}
                >
                  {item.is_active ? "Deactivate" : "Activate"}
                </Button>
              ) : <></>}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
